module.exports = __webpack_public_path__ + "img/19_66.5d71663e.png";